import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ReportsIntervalWisePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-reports-interval-wise',
  templateUrl: 'reports-interval-wise.html',
})
export class ReportsIntervalWisePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ReportsIntervalWisePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/reports-interval-wise/reports-interval-wise.ts